export default __webpack_public_path__ + "static/media/logo_full_br.6bfa8ddc.png";